<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('update_widget') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/widget/update/${widgetdata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('title') }}
                      </label>
                      <app-input class="col-md-8"
                                 type="text"
                                 v-model="widgetdata.title"
                                 :required="true"
                                 :placeholder="$t('title')"/>
                  </div>
                  <div class="form-group row align-items-center">
                    <label for="readonly_input" class="col-sm-2 mb-sm-0">
                        {{ $t('readonly') }}
                    </label>
                    <app-input id="readonly_input"
                               class="col-sm-8"
                               type="text"
                               v-model="widgetdata.slug"
                               :read-only="true"
                               :placeholder="$t('readonly_input')"/>
                </div>
                  <div class="form-group row">
                      <label for="inputs_editor" class="col-sm-2 h-fit-content">
                          {{ $t('description') }}
                      </label>
                      <div class="col-sm-8">
                          <app-input type="text-editor"
                                     :required="false"
                                     id="text-editor-id"
                                     :label="$t('message_placeholder')" v-model="widgetdata.description"/>
                      </div>
                  </div>

                  <div class="form-group row align-items-center">
                      <label class="col-md-2 mb-md-0">
                          {{ $t('status') }}
                      </label>
                          <app-input class="col-md-8 mt-2 pt-1"
                                     type="radio"
                                     :list="statusLists"
                                     v-model="widgetdata.status"
                                     :required="true"/>
                  </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateCMS",
        mixins: [FormMixin],
        props: ['widgetdata'],
        data(){
          return {
            reqdata:{
              title: '',
              description: '',
            }, 
            preloader: false,                
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.widgetdata)) {
                    if (value != null) formData.append(key, value);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>